const WISHLIST_KEY = 'zenee_wishlist';

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
  } catch {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

function isWishlisted(id) {
  return getWishlist().some((item) => item.id === id);
}

function toggleWishlist(product) {
  const list = getWishlist();
  const idx = list.findIndex((item) => item.id === product.id);
  if (idx > -1) {
    list.splice(idx, 1);
  } else {
    list.push(product);
  }
  saveWishlist(list);
  return idx === -1;
}

function updateWishlistCount() {
  const count = getWishlist().length;
  const badge = document.querySelector('.wishlist-count-bubble');
  if (!badge) return;
  if (count > 0) {
    badge.removeAttribute('hidden');
    const numEl = badge.querySelector('[aria-hidden]');
    if (numEl) numEl.textContent = count < 100 ? count : '99+';
  } else {
    badge.setAttribute('hidden', '');
  }
}

function setButtonState(btn, active) {
  btn.setAttribute('aria-pressed', String(active));
  btn.classList.toggle('wishlist-btn--active', active);
  const label = btn.dataset.productTitle
    ? (active ? 'Remove from wishlist: ' : 'Add to wishlist: ') + btn.dataset.productTitle
    : (active ? 'Remove from wishlist' : 'Add to wishlist');
  btn.setAttribute('aria-label', label);
}

function initWishlistButtons() {
  document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
    const id = String(btn.dataset.productId);
    if (!id) return;
    if (btn._wishlistInitialized) return;
    btn._wishlistInitialized = true;

    setButtonState(btn, isWishlisted(id));

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const product = {
        id: String(btn.dataset.productId),
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        price: btn.dataset.productPrice,
        image: btn.dataset.productImage,
        url: btn.dataset.productUrl,
      };
      const added = toggleWishlist(product);
      setButtonState(btn, added);
      updateWishlistCount();

      // sync any other buttons for the same product on the page
      document.querySelectorAll(`[data-wishlist-btn][data-product-id="${id}"]`).forEach((other) => {
        if (other !== btn) setButtonState(other, added);
      });
    });
  });
}

function buildWishlistCard(product) {
  const card = document.createElement('div');
  card.className = 'wishlist-page-card';
  card.dataset.productId = product.id;

  const imageHtml = product.image
    ? `<img src="${product.image}" alt="${product.title}" loading="lazy" class="wishlist-page-card__image">`
    : `<div class="wishlist-page-card__image wishlist-page-card__image--placeholder"></div>`;

  card.innerHTML = `
    <a href="${product.url}" class="wishlist-page-card__image-link">${imageHtml}</a>
    <div class="wishlist-page-card__info">
      <a href="${product.url}" class="wishlist-page-card__title full-unstyled-link">${product.title}</a>
      <p class="wishlist-page-card__price">${product.price}</p>
      <div class="wishlist-page-card__actions">
        <a href="${product.url}" class="button button--secondary wishlist-page-card__view">View product</a>
        <button class="wishlist-page-card__remove button button--tertiary" aria-label="Remove ${product.title} from wishlist" type="button">Remove</button>
      </div>
    </div>
  `;

  card.querySelector('.wishlist-page-card__remove').addEventListener('click', () => {
    const list = getWishlist().filter((i) => i.id !== product.id);
    saveWishlist(list);
    card.remove();
    updateWishlistCount();

    const grid = document.querySelector('.wishlist-page-grid');
    if (grid && grid.children.length === 0) {
      document.querySelector('.wishlist-empty')?.removeAttribute('hidden');
    }
  });

  return card;
}

function initWishlistPage() {
  const grid = document.querySelector('.wishlist-page-grid');
  if (!grid) return;

  const items = getWishlist();
  const emptyMsg = document.querySelector('.wishlist-empty');

  if (items.length === 0) {
    emptyMsg?.removeAttribute('hidden');
    return;
  }

  items.forEach((product) => grid.appendChild(buildWishlistCard(product)));
}

document.addEventListener('DOMContentLoaded', () => {
  initWishlistButtons();
  updateWishlistCount();
  initWishlistPage();
});

// Re-run after theme editor section reloads
document.addEventListener('shopify:section:load', () => {
  initWishlistButtons();
  updateWishlistCount();
});
